import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sysAid = defineConnector({
  identifier: "sysAid",
  name: "SysAid",
  tagLine: "IT service management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://.*\\.sysaidit\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.domain}/api/v1/application-keys`,
        jsonBody: {
          userName: app.config.username,
          password: app.secret.password,
        },
      },
      extract: { from: "cookie", name: "JSESSIONID" },
      apply: { kind: "cookie", name: "JSESSIONID" },
    }),
  steps: [
    {
      title: "Get your SysAid API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your SysAid instance and navigate to **Settings › Integration › API** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your SysAid details",
      items: [
        {
          kind: "hostname",
          label: "Account hostname",
          required: true,
          placeholder: "your-account.sysaidit.com",
          target: { kind: "configuration", field: "domain" },
          helperText: "Your SysAid account hostname.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/users?limit=1`,
  },
  publicEnvVars: ({ domain }) => ({
    SYS_AID_URL: domain ? `https://${domain}` : "",
  }),
});
